wbApp.controller('CzMsMtRegistryExportDetailCtrl', ['$scope', '$modal', 'czMsMtRegistrySvc', '$q', 'activitySvc',
function ($scope, $modal, czMsMtRegistrySvc, $q, activitySvc) {

    $scope.model = czMsMtRegistrySvc.newExportModel();
    $scope.activities = activitySvc.getInfoByRange($scope.model.fromDate, $scope.model.toDate);
    $scope.activities.$promise.then(function() {
        if (activitiesComboInstance != null) {
            $scope.model.activityIds =  _.map($scope.activities, 'id');
        }
    });
    
    let activitiesComboInstance = null;
    
    function initExportResponse() {
        $scope.exportResponse = {
            errors: [],
            filesToDownload: []
        };
    }
    
    $scope.onDateRangeChanged = function() {
        if ($scope.model.fromDate && $scope.model.toDate &&
            moment($scope.model.fromDate).isBefore(moment($scope.model.toDate))) {
            $scope.activities = activitySvc.getInfoByRange($scope.model.fromDate, $scope.model.toDate);
            $scope.activities.$promise.then(function() {
                if (activitiesComboInstance != null) {
                    $scope.model.activityIds =  _.map($scope.activities, 'id');
                } 
            });
        } else {
            $scope.activities = [];
        }
    }
    
    $scope.isGenerating = false;

    initExportResponse();
    
    $scope.getDownloadUrl = function(downloadUri) {
        return `/restapi/cz-ms-mt-registry/registry-export/${downloadUri}`
    }
    
    $scope.getFileName = function(downloadUri) {
        return downloadUri.split('-').pop();
    }
    
    $scope.onGenerateExport = function() {
        
        if ($scope.isGenerating) {
            return;
        }

        $scope.isGenerating = true;

        initExportResponse();      
        
        czMsMtRegistrySvc.exportToXml($scope.model).$promise.then(function(result) {
            $scope.exportResponse = result;
            $scope.isGenerating = false;
        }, function (error) {
            $scope.isGenerating = false;
        });
    }
    
    $scope.onErrorClick = function(id) {
        let modelPromise = czMsMtRegistrySvc.getById(id);
        $q.all([modelPromise.$promise, detailDialogPromise.$promise]).then(function() {
            detailDialogPromise.$scope.model = modelPromise;
            detailDialogPromise.$scope.onRegistryDetailSave = function () {
            };
            detailDialogPromise.show();
        });
    }
    
    $scope.onDruhProvozuChanged = function() {
        $scope.model.prumDobaCelodenniProvoz = 0;
        $scope.model.prumDobaPolodenniProvoz = 0;
        $scope.model.prumDobaInternatniProvoz = 0;
    }

    let detailDialogPromise = $modal({
        templateUrl: 'cz-ms-mt-registry/cz-ms-mt-registry-detail.html',
        show: false,
        scope: $scope.$new(true)
    });
    
    $scope.activitiesCombo = {
        //items: $scope.activities,
        displayExpr: 'name',
        valueExpr: 'id',
        showSelectionControls: true,
        maxDisplayedTags: 6,
        multiline: false,

        itemTemplate: 'customItem',
        bindingOptions: {
            items: 'activities',
            value: 'model.activityIds'
        },
        onInitialized: function (e) {
            activitiesComboInstance = e.component;
        }
    }
    
}]);
